<template>
  <div class="btn-wrapper">
    <div class="btn" v-if="activityStatus === 'CANCEL'">活动已取消</div>

    <!-- 未登录 -->
    <template v-else-if="!isLogin">
      <div class="btn is-active" v-if="activityStatus === 'BOOKING' || activityStatus === 'SIGNING'" @click="bookActivity">立即报名</div>
      <div class="btn" v-else-if="activityStatus === 'INTERM'">活动进行中</div>
      <div class="btn" v-else-if="activityStatus === 'OUTTERM'">活动已结束</div>
    </template>

    <!-- 已登录 -->
    <template v-else>
      <!-- 活动未开始 -->
      <template v-if="activityStatus === 'BOOKING' || activityStatus === 'SIGNING'">
        <!-- 组织者 -->
        <template v-if="activityUserInfo.creater">
          <div v-if="activityStatus === 'BOOKING'" class="btn btn-multi is-active" @click="showPopup('cancelActivityPopup')">
            取消活动<div class="btn-desc">活动将于 {{ detail.begin_time | formatTime('M 月 D 日 H:mm') }} 开始</div>
          </div>
          <div v-else class="btn is-active" @click="showSignQrcodePopup">组织组员签到</div>
        </template>

        <!-- 非组织者 -->
        <template v-else>
          <div v-if="activityUserSignStage === 'CANCEL'" class="btn">已取消报名</div>
          <div v-if="activityUserSignStage === 'HAS_NO_RIGHT'" class="btn">立即报名</div>
          <div v-else-if="activityUserSignStage === 'NORMAL'" class="btn" :class="hasRightBook ? 'is-active' : ''" @click="bookActivity">
            立即报名
            <div class="tip" v-if="needShowTip">当前剩余免费次数 {{ 2 - joinCount }} 次 <Icon code="&#xe617;" class="close" @click="showTip = false" /></div>
          </div>
          <div v-else-if="activityUserSignStage === 'AUDIT'" class="btn is-active">报名资格审核中</div>
          <div v-else-if="activityUserSignStage === 'AUDIT_FAIL'" class="btn btn-multi">报名失败<div class="btn-desc">未通过资格审核</div></div>
          <div v-else-if="activityUserSignStage === 'BACK'" class="btn is-active">
            名额已满，正在候补中
          </div>

          <!-- 待缴费 -->
          <template v-else-if="activityUserSignStage === 'TOPAY'">
            <!-- 线下支付 && 已下单 -->
            <div
              v-if="activityUserInfo.pay_channal == 12 && activityUserInfo.pay && activityUserInfo.pay.status == 1"
              class="btn btn-multi is-active"
              @click="showPopup('offlinePopup')"
            >
              <span>已提交订单，待支付 <span class="price-fee rmb">{{ activityUserInfo.pay && activityUserInfo.pay.fee | formatPrice }}</span></span><div class="btn-desc">查看付款信息</div>
            </div>
            <div v-else-if="payWay === 'TICKET'" class="btn btn-multi is-active" @click="goPay">
              待交费<div class="btn-desc">交费后即算报名成功</div>
            </div>
            <div v-else-if="payWay === 'MARGIN'" class="btn btn-multi is-active" @click="goPay">
              待交保证金<div class="btn-desc">交纳保证金即算报名成功</div>
            </div>
          </template>

          <!-- 待签到 -->
          <template v-else-if="activityUserSignStage === 'TOSIGN'">
            <!-- 活动报名阶段 -->
            <div
              v-if="activityStatus === 'BOOKING'"
              class="btn btn-multi is-active"
              @click="showPopup('activityUserCancelPopup')">
              取消报名<div class="btn-desc">活动开始前 2h 不可取消</div>
            </div>

            <!-- 活动签到阶段 -->
            <template v-else>
              <div
                class="btn is-active"
                v-if="!activityUserInfo.sign_in_time"
                @click="showWeChatScanPopup"
              >
                立即签到，参与活动
              </div>
            </template>
          </template>

          <!-- 完成整个活动 -->
          <div class="btn" v-else-if="activityUserInfo.status >= 20">已签到</div>
        </template>
      </template>

      <!-- 进行中 -->
      <template v-if="activityStatus === 'INTERM'">
        <!-- 创建者 -->
        <div
          v-if="activityUserInfo.creater"
          class="btn is-active"
          @click="showSignQrcodePopup"
        >
          组织组员签到
        </div>

        <!-- 非创建者 && 参与过活动 && 待签到状态 -->
        <div
          v-else-if="activityUserSignStage === 'TOSIGN' && activityUserInfo.status"
          class="btn is-active"
          @click="showWeChatScanPopup"
        >
          立即签到，参与活动
        </div>

        <!-- 非创建者 && 参与过活动 && 除待签到状态以外的状态 -->
        <div
          v-else-if="activityUserInfo.status"
          class="btn btn-multi"
        >
          活动已开始
          <div class="btn-desc">
            <template v-if="activityUserSignStage === 'BOOK_FAIL'">
              报名失败
            </template>
            <template v-else>
              已签到
            </template>
          </div>
        </div>

        <!-- 未参与过报名 -->
        <div v-else class="btn">已结束报名</div>
      </template>

      <!-- 已结束 -->
      <template v-if="activityStatus === 'OUTTERM'">
        <!-- 参与过报名 && 已经参加了活动 -->
        <template v-if="activityUserInfo.status && activityUserSignStage === 'SUCC'">
          <template v-if="detail.feedback_form_id">
            <div class="btn is-active" v-if="isFeedback === false" @click="fillFeedForm">填写活动反馈</div>
            <div class="btn" v-else-if="isFeedback">已填写活动反馈</div>
          </template>
          <div class="btn" v-else>活动已结束</div>
        </template>
        <div class="btn" v-else>活动已结束</div>
      </template>
    </template>

    <!-- 弹窗部分 -->
    <!-- 弹窗：供组织者用的签到码 -->
    <comModal
      ref="signQrcodePopup"
      :closeable="false"
      @close="qrcodeLink = ''"
    >
      <div slot="title">扫码签到</div>

      <div slot="desc" class="sign-qrcode-desc">
        <Qrcode :val="qrcodeLink" :size="180"></Qrcode>
      </div>

      <div slot="btn"></div>
    </comModal>

    <!-- 弹窗：提醒去微信扫码 -->
    <comModal
      ref="goWeChatScan"
      :closeable="false"
      @close="mpCode = ''"
    >
      <div slot="title">请使用微信扫描下方二维码登录小程序进行签到</div>

      <div slot="desc">
        <img :src="mpCode" class="mp-code">
      </div>

      <div slot="btn"></div>
    </comModal>

    <!-- 弹窗：组织者取消活动 -->
    <comModal
      ref="cancelActivityPopup"
      :closeable="false"
    >
      <div slot="title">取消活动</div>

      <div slot="desc">如需取消活动，请联系客服并说明原因</div>

      <div slot="btn-confirm">确定</div>
    </comModal>

    <!-- 弹窗：活动已取消 -->
    <comModal
      ref="activityCancelPopup"
      @confirm="goActivityList"
    >
      <div slot="title">活动已取消</div>

      <div slot="desc">活动已取消，您可联系客服了解活动取消原因</div>

      <div slot="btn-confirm">返回活动列表</div>
    </comModal>

    <!-- 弹窗：报名资格审核中 -->
    <comModal
      ref="auditPopup"
      :closeable="true"
    >
      <div slot="title">活动报名表已提交</div>

      <div slot="desc">
        报名资格审核中，请耐心等待运营的确认消息
      </div>

      <div slot="btn-confirm">查看活动详情</div>
    </comModal>

    <!-- 弹窗：报名失败 未通过资格审核 -->
    <comModal
      ref="auditFailedPopup"
      :closeable="true"
    >
      <div slot="title">活动报名失败</div>

      <div slot="desc">
        很遗憾，您报名的<text class="popup-desc-stress">「{{ detail.title }}」</text>活动未能通过审核，您可继续报名其他活动
      </div>

      <div
        slot="btn-confirm"
        @confirm="goActivityList"
      >查看更多活动</div>
    </comModal>

    <!-- 弹窗：非组织者用户要取消活动 -->
    <comModal
      ref="activityUserCancelPopup"
      @confirm="confirmCancelActivity('activityUserCancelPopup')"
    >
      <div slot="title">取消报名</div>

      <div slot="desc">
        <template v-if="!payWay">
          取消报名后不可再次报名
        </template>

        <template
          v-else-if="
            (isVIP || (!isVIP && joinCount < joinCountForFree)) &&
            detail.curr_time <= detail.begin_time - 24 * 60 * 60
          "
        >
          <template v-if="payWay === 'MARGIN'">
            取消报名后不可再次报名，保证金将由原路退还
          </template>
          <template v-else>
            取消报名后不可再次报名
          </template>
        </template>

        <template v-else>
          取消报名后不可重新报名本场活动，活动报名费将纳为本次活动经费不予退还
        </template>
      </div>

      <div slot="btn-confirm">确定取消</div>
    </comModal>

    <!-- 弹窗：用户报名成功后进入候补 -->
    <comModal
      ref="BACKPopup"
      :closeable="false"
    >
      <div slot="title">报名失败，候补中</div>

      <div slot="desc">
        名额已满，当前已进入候补队列中，如有名额空出，会按照优先顺序自动加入，届时会有短信提醒。
      </div>

      <div slot="btn-confirm">确定</div>
    </comModal>

    <!-- 弹窗：用户报名成功后进入待缴费 -->
    <comModal
      ref="ToPayPopup"
      @confirm="confirmToPayPopup"
    >
      <div slot="title">距离报名成功还差一步</div>

      <div slot="desc">
        <template v-if="payWay === 'TICKET'">
          当前活动需交费，去交费？
        </template>
        <template v-else>
          当前活动需缴纳保证金，成功参与活动后，保证金会原路退回，去缴纳保证金？
        </template>
      </div>

      <div slot="btn-confirm">去交费</div>
    </comModal>

    <!-- 弹窗：用户报名成功后进入待签到-->
    <comModal
      ref="ToSignPopup"
      :closeable="false"
    >
      <div slot="title">报名成功</div>

      <div slot="desc">
        活动将于 {{ detail.begin_time | formatTime('M 月 D 日 H:mm') }} 开始，提前两个小时可签到
      </div>

      <div slot="btn-confirm">确定</div>
    </comModal>

    <!-- 弹窗：线下支付 -->
    <offlinepayModal
      ref="offlinePopup"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import VueTypes from 'vue-types'
import utils from '../../util'
import Icon from '../../components/Icon'
import ComModal from '../../components/modal/ComModal.vue'
import offlinepayModal from '../../components/modal/OfflinePayPopup.vue'
import Qrcode from '../../components/com-qrcode'

import TGOServer from '../../service'
import InfoQServer from '../../service/infoq.service'
import miscServer from '../../service/misc.service'

import {
  payMethod,
  activityStatusInfo,
  activityPublishedStatusInfo,
  activityUserSignStageInfo,
  joinCountForFree
} from '../../service/basicData'

const SIGN_DURATION = 2 * 60 * 60 // 签到时长
const SIGN_LINK = 'https://tgo.infoq.cn/event/sign'
const GETCODE_DURATION = 5000
let _payRulePromise = ''

export default {
  name: 'EventStatus',
  data: () => ({
    showTip: true,
    rulesShowTip: false,
    joinCount: 0,
    joinCountForFree,

    qrcodeLink: '',
    mpCode: '',

    activityStatus: '', // 活动状态值

    isVIP: false,
    // 是否已经填写活动反馈表
    isFeedback: false,
    // 用户参与活动的所有信息
    activityUserInfo: {},
    // 用户参与活动的当前状态值
    activityUserSignStage: '',
    // 缴费方式：门票或保证金 TICKET MARGIN
    payWay: '',
    // 是否有权限参与报名
    hasRightBook: true
  }),
  components: {
    Icon,
    ComModal,
    offlinepayModal,
    Qrcode
  },
  props: {
    // 活动详情
    detail: VueTypes.object
  },
  computed: {
    ...mapState([
      'isLogin'
    ]),

    id () {
      return this.$route.params.id
    },

    needShowTip () {
      return this.showTip && this.rulesShowTip
    }
  },
  created () {
    this.setActivityStatus(this.detail)
  },
  mounted () {
    // this.showWeChatScanPopup()
  },
  methods: {
    // 设置状态值
    setActivityStatus (detail) {
      let activityStatus = activityStatusInfo[detail.status]

      if (activityStatus === 'PUBLISHED') {
        detail.curr_time = Number(detail.curr_time)
        detail.begin_time = Number(detail.begin_time)
        detail.end_time = Number(detail.end_time)

        // 报名阶段
        if (detail.curr_time < detail.begin_time - SIGN_DURATION) {
          activityStatus = activityPublishedStatusInfo.BOOKING
        }
        // 签到阶段
        if (detail.curr_time >= detail.begin_time - SIGN_DURATION && detail.curr_time < detail.end_time) activityStatus = activityPublishedStatusInfo.SIGNING
        // 进行中
        if (detail.curr_time >= detail.begin_time && detail.curr_time <= detail.end_time) activityStatus = activityPublishedStatusInfo.INTERM
        // 已结束
        if (detail.curr_time > detail.end_time) {
          activityStatus = activityPublishedStatusInfo.OUTTERM

          // 需填写表单
          if (this.isLogin && detail.feedback_form_id) {
            InfoQServer.getFormSubmitStatus(Number(detail.feedback_form_id))
              .then(res => {
                this.isFeedback = res.result
              })
              .catch(err => {
                console.log(err)
              })
          }
        }

        // 获取用户活动状态
        this.getUserActivityStatus(this.id, activityStatus)
      }

      this.activityStatus = activityStatus
      // this.activityStatus = 'BOOKING'
      // this.activityStatus = 'SIGNING'
      // this.activityStatus = 'INTERM'
      // this.activityStatus = 'OUTTERM'

      this.setPopup()
    },

    setPopup () {
      if (this.activityStatus === 'CANCEL') {
        this.showPopup('activityCancelPopup')
      }
    },

    // 获取用户活动状态
    getUserActivityStatus (id, activityStatus = '') {
      return new Promise((resolve, reject) => {
        TGOServer.getUserActivityStatus({ event_id: Number(id) })
          .then(res => {
            let activityUserSignStage = activityUserSignStageInfo[res.status || 0]

            TGOServer.getUserInfo()
              .then((response) => {
                this.isVIP = response.is_member
                this.joinCount = Number(response.join_count)

                this.rulesShowTip = !this.isVIP && this.joinCount < joinCountForFree
              })
              .catch(err => {
                console.log(err)
              })

            // 活动已结束后不用弹窗
            if (activityStatus !== 'OUTTERM') {
              if (activityUserSignStage === 'HAS_NO_RIGHT') {
                utils.toast('您暂未获得报名权限')
              } else if (activityUserSignStage === 'AUDIT_FAIL') {
                this.showPopup('auditFailedPopup')
              } else if (activityUserSignStage === 'AUDIT') {
                this.showPopup('auditPopup')
              } else if (activityUserSignStage === 'BACK') {
                this.showPopup('BACKPopup')
              // 待交费和待签到状态，需判定出保证金还是交门票
              } else if (
                activityUserSignStage === 'TOPAY' ||
                activityUserSignStage === 'TOSIGN'
              ) {
                this.setPayMethod().then(() => {
                  this.showPopup(activityUserSignStage === 'TOPAY' ? 'ToPayPopup' : 'ToSignPopup')
                })
              }
            }

            this.activityUserInfo = res
            // 设置用户参与活动状态值
            this.activityUserSignStage = activityUserSignStage

            resolve()
          })
          .catch(err => {
            console.log('获取用户活动状态接口报错', err)
            reject(err)
          })
      })
    },

    async setPayMethod () {
      let { payWay } = await this.getPayRule({ detail: this.detail })

      console.log(payWay)

      this.payWay = payWay
    },

    // 获取付款的规则、订单信息
    getPayRule ({ detail, force = false }) {
      if (_payRulePromise && !force) {
        return _payRulePromise
      }

      let res = {
        payWay: '',
        orderInfo: {
          event_id: detail.id,
          list: []
        }
      }

      const goods = {
        count: 1,
        sku: 0,
        price: {
          actual: 0
        }
      }

      function getGoodsOrder ({ isTicket }) {
        return Object.assign({}, goods, {
          sku: isTicket
            ? detail.ticket_sku
            : detail.margin_sku,
          price: {
            actual: isTicket
              ? detail.ticket_amount * detail.ticket_price
              : detail.margin_amount * detail.margin_price
          },
          name: isTicket ? detail.title : ''
        })
      }

      _payRulePromise = new Promise(resolve => {
        console.log(detail.ticket_amount, detail.member_is_paid)
        // 活动付费，会员付费，无需保证金 => 门票
        if (
          detail.ticket_amount > 0 &&
          detail.member_is_paid &&
          detail.margin_amount === 0
        ) {
          res.payWay = payMethod.TICKET

          res.orderInfo = Object.assign({}, res.orderInfo, {
            list: [getGoodsOrder({ isTicket: true })]
          })

          resolve(res)

        // 活动免费，需保证金 => 保证金
        } else if (
          detail.ticket_amount === 0 &&
          detail.margin_amount > 0
        ) {
          res.payWay = payMethod.MARGIN

          res.orderInfo = Object.assign({}, res.orderInfo, {
            list: [getGoodsOrder({ isTicket: false })]
          })

          resolve(res)

        // 活动付费，学员免费，需保证金
        } else if (
          detail.ticket_amount > 0 &&
          !detail.member_is_paid &&
          detail.margin_amount > 0
        ) {
          TGOServer.getUserInfo()
            .then((response) => {
              console.log(response)
              let isVIP = response.is_member
              let joinCount = Number(response.join_count)

              if (isVIP || joinCount < joinCountForFree) {
                res.payWay = payMethod.MARGIN

                res.orderInfo = Object.assign({}, res.orderInfo, {
                  list: [
                    getGoodsOrder({ isTicket: true }),
                    getGoodsOrder({ isTicket: false })
                  ]
                })

                resolve(res)
              } else {
                res.payWay = payMethod.TICKET

                res.orderInfo = Object.assign({}, res.orderInfo, {
                  list: [
                    getGoodsOrder({ isTicket: true })
                  ]
                })

                resolve(res)
              }
            })
            .catch(err => {
              console.log(err)
              resolve(res)
            })
        } else {
          resolve(res)
        }
      })

      return _payRulePromise
    },

    // 立即报名
    bookActivity () {
      if (!this.isLogin) {
        utils.login()
        return
      }

      if (!this.hasRightBook) return

      let formId = this.detail.form_id
      if (Number(formId) && !this.activityUserInfo.form_result) {
        utils.goWebForm(formId)
      } else {
        TGOServer.signupActivity({ event_id: Number(this.id) })
          .then(res => {
            if (res.result) {
              // this.getdetail(this.id)

              this.getUserActivityStatus(this.id)
                .then(() => {
                  // if (this.activityUserSignStage === 'BACK') {
                  //   this.showPopup('BACKPopup')
                  // } else if (this.activityUserSignStage === 'TOPAY') {
                  //   this.showPopup('ToPayPopup')
                  // } else if (this.activityUserSignStage === 'TOSIGN') {
                  //   this.showPopup('ToSignPopup')
                  // }
                })
            }
          })
          .catch(err => {
            console.log(err)
            if (err && err.code === -5043) {
              utils.toast('您暂未获得报名权限')
              this.hasRightBook = false
            }
          })
      }
    },

    // 去缴费
    async goPay () {
      let { orderInfo } = await this.getPayRule({ detail: this.detail })

      utils.goPayment(JSON.stringify(orderInfo))
    },

    confirmToPayPopup () {
      // 如果已提交订单，只弹窗就好，不需要进结算台
      if (
        `${this.activityUserInfo.pay_channal}` === '12' &&
        this.activityUserInfo.pay &&
        `${this.activityUserInfo.pay.status}` === '1'
      ) {
        this.showPopup('offlinePopup')

        return
      }

      this.goPay()
    },

    // 填写反馈表单
    fillFeedForm () {
      if (!this.isLogin) {
        utils.login()
        return
      }

      utils.goWebForm(this.detail.feedback_form_id)
    },

    confirmCancelActivity () {
      this.cancelSignupActivity()
    },

    cancelSignupActivity () {
      TGOServer.cancelSignupActivity({ event_id: Number(this.id) })
        .then(res => {
          if (res.result) {
            utils.toast('您已成功取消活动')

            this.getUserActivityStatus(this.id)
          }
        })
        .catch(err => {
          console.log('取消报名活动接口报错', err)
        })
    },

    showSignQrcodePopup () {
      this.showPopup('signQrcodePopup')

      this.getActivitySignCodeInterval(this.id)
    },

    getActivitySignCode (id) {
      TGOServer.getActivitySignCode({ event_id: Number(id) })
        .then(res => {
          this.qrcodeLink = `${SIGN_LINK}?event_id=${this.id}&code=${res.code}`
        })
        .catch(err => {
          console.log('获取用户活动签到码接口报错', err)
        })
    },

    getActivitySignCodeInterval (id) {
      this.getActivitySignCode(id)

      if (window.getActivitySignCodeTimer) clearInterval(window.getActivitySignCodeTimer)
      window.getActivitySignCodeTimer = setInterval(() => {
        this.getActivitySignCode(id)
      }, GETCODE_DURATION)
    },

    showWeChatScanPopup () {
      this.showPopup('goWeChatScan')

      let opt = {
        app_id: 'wx4d8c063ab7630423',
        page: 'pages/activitydetail/activitydetail',
        scene: `id=${this.id}`,
        env_version: process.env.VUE_APP_BUILD_ENV === 'prod' ? 'release' : 'trial'
      }

      miscServer.getMpCode(opt)
        .then(blob => {
          this.mpCode = URL.createObjectURL(blob)
        })
        .catch(err => {
          console.log(err)
        })
    },

    goActivityList () {
      window.location.href = 'https://tgo.infoq.cn/event'
    },

    showPopup (name) {
      this.$refs[name] && this.$refs[name].show()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../style/bulma/app.sass';

.btn-wrapper {
  height: 90px;
  @include flexCenter;
}

.btn {
  position: relative;
  @include flexCenter;
  flex-direction: column;
  width: 300px; height: 50px;
  padding-top: 3px;
  text-align: center;
  border-radius: 4px;
  background: $color-gray-5;
  font-size: 18px; font-weight: 500;
  color: #fff;
  line-height: 1;
  cursor: pointer;

  &.btn-multi {
    padding-top: 0px;
    font-size: 18px; font-weight: 500;
    line-height: 1;
    .btn-desc {
      margin-top: 5px;
      font-size: 12px; font-weight: 500;
    }
  }

  &.is-active {
    color: $color-orange2;
    background: $primary3;
  }

  .tip {
    position: absolute; right: -55px; top: -25px;
    display: flex; align-items: center; justify-content: space-between;
    width: 200px; height: 32px;
    padding: 2px 6px 0 12px;
    border-radius: 4px;
    background: $color-red;
    font-size: 14px;
    color: #fff;

    .close {
      font-size: 18px;
      transform: translateY(-2px);
      cursor: pointer;
    }

    &::before {
      content: '';
      position: absolute; left: 20px; bottom: -7px;
      width: 0; height: 0;
      border: 4px solid transparent;
      border-top-color: $color-red;
    }
  }
}

.mp-code {
  width: 180px;
}
.sign-qrcode-desc {
  margin-top: 20px;
}

// 线下支付
.cashier {
  margin: -10px 0 17px;
  text-align: center;

  .cashier-title, .cahier-time {
    font-size: 12px;
    color: $color-text-dark;
  }
}
.price {
  margin: 5px 0 6px;
  font-family: DINAlternateBold;
  font-size: 24px; font-weight: 700;
  color: $color-text-dark;
  line-height: 1;
  &.rmb {
    &::before {
      content: '¥';
      margin-left: 2px;
      margin-right: 2px;
      font-size: 12px;
      font-weight: 400;
      line-height: 1;
    }
  }
}

.price-fee {
  font-family: DINAlternateBold;
  font-size: 20px;
   &.rmb {
    &::before {
      content: '¥';
      margin-left: 1px;
      margin-right: 1px;
      font-size: 18px;
      // font-weight: 400;
      line-height: 1;
    }
  }
}

</style>
